import React, {useEffect, useRef} from "react";
import {Controller, useFormState} from "react-hook-form";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import {FindLoad, getNestedError} from "utils";
import {Loader} from "../loaders";
import {Svg} from "assets";

export const SelectMain = ({
                               classNameWrapper,
                               labelHeader,
                               control,
                               name,
                               rules,
                               placeholder,
                               list,
                               renderLabel,
                               disabled,
                               loading,
                               loadType,
                               StartIcon,
                               disableClearable,
                               selectedValue,
                               allowError = true,
                               handleChange = ()=>{},
                               CustomLastElement,
                               filterOptions,
                           }) => {
    const loader = FindLoad(loadType);
    const inputRef = useRef(null);
    const prevHasError = useRef(false);
    const { errors } = useFormState({ control });
    const error = getNestedError(errors, name);
    const hasError = !!error?.type;

    useEffect(() => {
        if (hasError && !prevHasError.current && inputRef.current) {
            inputRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        prevHasError.current = hasError;
    }, [hasError]);

    return (
        <div
            className={`input-main-wrapper input-custom-wrapper ${
                classNameWrapper ? classNameWrapper : ""
            }`}
        >
            <Controller
                control={control}
                name={name}
                rules={rules}
                render={({
                             field,
                             field: {onChange, value},
                             formState: {errors},
                         }) => {

                    const selectedOption = list?.length && list?.find((item) => item?.[selectedValue] === value) || null;

                    return (
                        <>
                            {labelHeader && (
                                <p
                                    className={`input-main-label-header ${
                                        errors[field?.name]?.message ? "errorLabel" : ""
                                    }`}
                                >
                                    {labelHeader}
                                    {rules?.required && (
                                        <span className="input-main-label-header-required">*</span>
                                    )}
                                </p>
                            )}
                            <Autocomplete
                                {...field}
                                key={field.value}
                                disabled={disabled}
                                disableClearable={disableClearable}
                                filterOptions={filterOptions}
                                id="checkboxes-tags-demo"
                                sx={{
                                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                        borderColor: errors[field?.name]?.message
                                            ? "#E63946"
                                            : "rgba(9, 30, 66, 0.53)",
                                    },
                                }}
                                popupIcon={!!loader?.length || loading ? (
                                    <Loader
                                        styles={{
                                            position: "absolute",
                                            right: 9,
                                            width: 15,
                                            height: 15,
                                        }}
                                    />
                                ) : <Svg.SelectArrowSvg/>}
                                options={list || []}
                                value={selectedValue ? selectedOption : value ?? null}
                                getOptionLabel={(option) => renderLabel(option) ?? ""}
                                isOptionEqualToValue={(option, value) =>
                                    option?.id === value?.id
                                }
                                onChange={(event, item) => {
                                    onChange(item ? (selectedValue ? item[selectedValue] : item) : null)
                                    handleChange(item ? (selectedValue ? item[selectedValue] : item) : null)
                                }}
                                renderOption={(props, option, {selected}) => {
                                    const lastElement = option?.id === list[list.length - 1]?.id;
                                    return (
                                        <>
                                            <li
                                                {...props}
                                                key={option?.id || option?.value}
                                                className={`main-select-option ${
                                                    selected ? "main-select-option-selected" : ""
                                                }`}
                                                style={option?.style ? option?.style : {}}
                                            >
                                                {option?.Icon && <option.Icon className='main-select-option-round-icon'/>}
                                                {renderLabel(option)}
                                            </li>
                                            {lastElement && CustomLastElement &&
                                                <li className='select-custom-last-element-wrapper'>
                                                    {CustomLastElement}
                                                </li>
                                            }
                                        </>
                                    );
                                }}
                                renderInput={(params) => {
                                    const IconInList = list?.length && list?.find((list) => list?.name === params?.inputProps?.value)?.Icon
                                    const IconStart = IconInList || StartIcon

                                    return (
                                        <TextField
                                            {...params}
                                            placeholder={placeholder}
                                            inputRef={(el) => {
                                                field.ref(el);
                                                inputRef.current = el;
                                            }}
                                            error={hasError}
                                            InputProps={
                                                IconStart
                                                    ? {
                                                        ...params.InputProps,
                                                        startAdornment: IconStart ? (
                                                            <IconStart/>
                                                        ) : <div/>,
                                                    }
                                                    : {...params.InputProps}
                                            }
                                        />
                                    )
                                }}
                            />
                            {allowError &&
                                <p className="error-message">{error?.message}</p>
                            }
                        </>
                    );
                }}
            />
        </div>
    );
};
